// Vike hook: fires when a client-side navigation finishes. Resets the
// navigation state so <LoaderBar> hides.
// eslint-disable-next-line no-restricted-imports
import { setNavigationState } from "../src/shared/Router/transitionStore";

export function onPageTransitionEnd() {
  setNavigationState("idle");
}
